import axios from 'axios';
import Vue from 'vue';
import router from '../router'


axios.defaults.timeout = 30000;

//加载等待框
// let loading = null;

//http request 拦截器
axios.interceptors.request.use(
  config => {
    config.headers = {
      'Content-Type': 'application/json'
    }
    return config;
  },
  error => {
    return Promise.reject(err);
  }
);

//http response 拦截器
axios.interceptors.response.use(
  response => {
      let data = response.data;
      return data;
  },
  error => {
    console.log('网络请求失败，请重试');
    return false;
  }
)

/**
 * 请求地址处理
 * @param {*} actionName action方法名称
 *本地 http://192.168.31.187:8080/
 *生产 http://test.glkj.online/face-merge/
 */
export function adornUrl(actionName) {
  // 非生产环境 && 开启代理, 接口前缀统一使用[/proxyApi/]前缀做代理拦截!
  return (process.env.NODE_ENV !== 'production' && process.env.OPEN_PROXY ? 'http://test.glkj.online/face-merge/' : 'http://test.glkj.online/face-merge/') + actionName
}


// 请求结果处理
//vueComponent Vue 组件对象
//data 请求返回数据
function responseHandle(vueComponent, data = {}) {
  if(data){
    if(data.code == -1){
      console.log('code = -1');
    }else{
      return data
    }
  }
}



/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, params = {}) {
  let self = this;
  return new Promise((resolve, reject) => {
    axios.get(adornUrl(url), {
        params: params
      })
      .then(response => {
        let data = responseHandle(self, response);
        if (data != null) {
          resolve(data);
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
  let self = this;
  return new Promise((resolve, reject) => {
    axios.post(adornUrl(url), data)
      .then(response => {
        let data = responseHandle(self, response);
        if (data != null) {
          resolve(data);
        }
      }, err => {
        reject(err)
      })
  })
}



// WEBPACK FOOTER //
// ./src/assets/http.js